import { AutocompleteInput } from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CalendarClock } from "lucide-react";
import {
  Create,
  DateInput,
  NumberInput,
  ReferenceInput,
  SimpleForm,
  TextInput,
} from "../common";
import { StatusSelectInput } from "../../documents/shared/StatusSelectInput";

const statusChoices = [
  { id: "pending", name: "Pending" },
  { id: "approved", name: "Approved" },
  { id: "rejected", name: "Rejected" },
  { id: "cancelled", name: "Cancelled" },
];

const calculateDays = (data: any) => {
  if (!data.from_date || !data.to_date) return data;
  const from = new Date(data.from_date);
  const to = new Date(data.to_date);
  let days = 0;
  for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
    const day = d.getDay();
    if (day !== 0 && day !== 6) days += 1;
  }
  return { ...data, days: data.days || Math.max(days, 0) };
};

export const LeaveRequestCreate = () => (
  <Create title="Create Leave Request" transform={calculateDays}>
    <SimpleForm className="max-w-3xl mx-auto space-y-6">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <CalendarClock className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">Request Leave</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ReferenceInput source="employee_id" reference="employees">
              <AutocompleteInput label="Employee" optionText="name" />
            </ReferenceInput>
            <ReferenceInput source="leave_type_id" reference="hr_leave_types">
              <AutocompleteInput label="Leave Type" optionText="name" />
            </ReferenceInput>
            <DateInput source="from_date" />
            <DateInput source="to_date" />
            <NumberInput
              source="days"
              helperText="Auto-filled from dates if left blank."
            />
            <StatusSelectInput
              source="status"
              choices={statusChoices}
              defaultValue="pending"
            />
          </div>
          <TextInput source="reason" multiline fullWidth className="mt-4" />
        </CardContent>
      </Card>
    </SimpleForm>
  </Create>
);
